var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 16,
    viewBox: "0 0 32 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 16,
    rx: 2,
    fill: "#596070"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02344 12H7.85059C9.34961 12 10.2529 11.248 10.2529 10.0127V10.0029C10.2529 9.0752 9.60352 8.38672 8.60254 8.28418V8.26465C9.34473 8.15723 9.90625 7.46875 9.90625 6.72656V6.7168C9.90625 5.65234 9.08594 4.9541 7.83594 4.9541H5.02344V12ZM7.57227 5.84766C8.36328 5.84766 8.81738 6.2041 8.81738 6.84863V6.8584C8.81738 7.56641 8.29492 7.95703 7.32812 7.95703H6.11719V5.84766H7.57227ZM7.55273 8.80176C8.59766 8.80176 9.13477 9.19238 9.13477 9.94922V9.95898C9.13477 10.7109 8.60742 11.1064 7.62598 11.1064H6.11719V8.80176H7.55273ZM11.1953 12H15.668V11.0576H12.2891V8.87012H15.4873V7.95215H12.2891V5.89648H15.668V4.9541H11.1953V12ZM18.5391 12H19.6328V5.89648H21.7861V4.9541H16.3809V5.89648H18.5391V12ZM21.1904 12H22.3379L22.9873 10.0957H25.7021L26.3467 12H27.4941L24.9355 4.9541H23.7539L21.1904 12ZM24.335 6.12109H24.3545L25.4043 9.2168H23.2803L24.335 6.12109Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeta);
export default __webpack_public_path__ + "static/media/beta.e662b7dc97638e4fd98792614a17f359.svg";
export { ForwardRef as ReactComponent };